import React from 'react';
import PropTypes from 'prop-types';
import './Input.css';
import {
  FormGroup,
  ControlLabel,
  FormControl,
  HelpBlock
} from 'react-bootstrap';

function getValidationState(touched, error, warning) {
  if (touched && error) {
    return 'error';
  }

  if (touched && warning) {
    return 'warning';
  }

  return null;
}

function Input({
  label,
  type,
  input,
  meta: { touched, error, warning, submitting },
  validationState = null,
  hideErrors = false,
  hideWarnings = false,
  disabled = false,
  disableOnSubmitting = false,
  inputMutator,
  children,
  ...otherProps
}) {
  if (!validationState) {
    validationState = getValidationState(touched, error, warning);
  }

  let disable = disabled || (disableOnSubmitting && submitting);

  if (inputMutator) {
    input = Object.assign({}, input, inputMutator(input));
  }

  return (
    <div className="input-container">
      <FormGroup validationState={validationState}>
        <ControlLabel>{label}</ControlLabel>
        <FormControl type={type} disabled={disable} {...input} {...otherProps}>
          {children}
        </FormControl>
        {touched &&
          ((error && !hideErrors && <HelpBlock>{error}</HelpBlock>) ||
            (warning && !hideWarnings && <HelpBlock>{warning}</HelpBlock>))}
      </FormGroup>
    </div>
  );
}

Input.propTypes = {
  label: PropTypes.string,
  type: PropTypes.string,
  input: PropTypes.object,
  meta: PropTypes.object,
  validationState: PropTypes.string,
  hideErrors: PropTypes.bool,
  hideWarnings: PropTypes.bool
};

export default Input;



// WEBPACK FOOTER //
// ./src/components/Input/index.js